// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__XCp-U","headerText":"styles_headerText__XsSNU","titleText":"styles_titleText__rDMpW","date":"styles_date__4Hwu7","orderButton":"styles_orderButton__L3Zew"};